<template>
    <div class="product-review">
        <CampaignList
            :lbl="lbl"
            :isLoading='isLoading'
            :initListConfig="listConfig"
            :initFilterConfig="filterConfig"
            :busEvent="busCampaign"
            :type="'review'"
            @toggleLoading="toggleLoading($event)" />
        <!-- <div class="product-review-list" v-for="(v,k) in 3" :key="k">
            <div class="product-review-item">
                <div class="img">
                    <img :src="`${pictureUrl}/Sensibio H2O F250ml sans parfum LD@3x.png`"/>
                </div>
                <div class="detail">
                    <div class="text-name">Sensibio H2O sans parfum LD</div>
                    <div class="wrapper-point">
                        <div class="box-point">
                            <div class="text-get">{{lbl.get}}</div>
                            <div class="product-point">
                                <div class="text">
                                <span class="use-point">{{2 | number_format}}</span>
                                    <span>
                                        <img class="icon-point" src="@/assets/icon/reward_icon_coin@3x.png" />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="btn-review">
                        รีวิว
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
import Vue from "vue";
import ConfigManager from "@/config/ConfigManager.js";
//component
import CampaignList from "@/module/List/component/CampaignList.vue";
//core
import {
  CampaignListConfigBuilder,
  CampaignListFilterConfigBuilder
} from "@/core/Campaign/model/CampaignConfigModel.js";

export default {
    name: 'ProductReview',
    components: {
        CampaignList,
    },
    props:{
        lbl: Object,
        mission: Object,
        modalController: Object,
    },
    data: function(){
        return {
            pictureUrl: ConfigManager.getBlobUrl() + '/config/bioderma/mission/review',
            isLoading: false,
            listConfig: {},
            filterConfig: {},
            busCampaign: new Vue(),
        }
    },
    created: function(){
        this.initialConfig();
    },
    methods: {
        //initial
        initialConfig: function() {
            var configStr = ConfigManager.getCampaignConfig();
            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(configStr.campaignReviewListConfig)
                
            this.listConfig = listConfig.create();

            var filterConfig = new CampaignListFilterConfigBuilder().create();
            this.filterConfig = filterConfig;
        },
        //utilities
        showLoading: function() {
            setTimeout(() => {
                this.modalController.loadingModal.show();
            },0)
        },
        hideLoading: function() {
            setTimeout(() => {
                this.modalController.loadingModal.hide();
            },300)
        },
        toggleLoading: function (isLoading) {
            this.isLoading = isLoading;
            if(this.isLoading){
                this.showLoading();
            }else{
                this.hideLoading();
            }
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
.product-review{
    padding: {
        top: $topbar-height + 20px;
        bottom: 30px;
    }
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import "@/style/base/baseImage.scss";
@import "@/style/base/baseText.scss";
@import "../style/ProductReview.scss";
</style>